var exports = {
  "Z": "xfd349460--a4d7c5--marks",
};

module.exports = exports;
